const initialState = {
  authorized: false,
  message: '',
  loading: false,
  error: '',
  user: {
    id: null,
    email: null,
  }
};

const auth = ( state = initialState, action ) => {
	// must return the same state or an updated version of the state
  const actionLookup = {
    'AUTH_SET': () => {
      if(action.authenticated){
        return {
          ...state, 
          authorized: action.authenticated,
          user: action.user,
          loading: false
        }
      } else {
        return {...initialState}
      }
    },
    'AUTH_LOADING': () => ({...state, loading: action.loading}),
    'AUTH_ERROR': () => ({...state, error: action.error}),
    'AUTH_MESSAGE': () => ({...state, message: action.message})
  };
  return actionLookup[action.type] ? actionLookup[action.type](state, action) : {...state}; // if the action type exists, execute action, otherwise returns default state
};

export default auth;


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js